import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { SetContentPermissions } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SetContentPermissionsAction extends Action {
  content: IContentInfo[];
}

export function setContentPermissions(content: IContentInfo[]) {
  return {
    type: SetContentPermissions,
    content: content
  };
}

export const isSetWorkbookPermissionsAction = isActionFactory<SetContentPermissionsAction>(SetContentPermissions);
